import PageBanner from "app/components/ui/PageBanner"
import HelmetTitle from "app/meta/HelmetTitle"
import React from 'react'
import './styles/ServicesPage.css'
import MakeAppointment from "app/components/homepage/MakeAppointment"
import PageSection from "app/components/ui/PageSection"
import sectionImg1 from 'app/assets/images/dermatology-1.jpg'
import sectionImg2 from 'app/assets/images/dermatology-2.jpg'
import AppButton from "app/components/ui/AppButton"
import SiteGrid from "app/components/ui/SiteGrid"
import IconsBarSection from "app/components/ui/IconsBarSection"
import { dermatologyData } from "app/data/servicesData"

export default function DermatologyPage() {
  return (
    <div className="dermatology-page services-page">
      <HelmetTitle title="Dermatology" />
      <PageBanner
        title="Dermatology"
        subtitle="Discovering the Beauty in Healthy Skin: Your Dermatology Guide to a Confident You"
      />
      <div className="page-content">
        <PageSection
          subtitle="Your Skin's Health Matters"
          title="Our Comprehensive Dermatology Services and Treatments"
          text={<p>
            Your skin is your body's largest organ and plays a vital
            role in your overall health and well-being. That's why our
            healthcare center offers comprehensive dermatology services
            to help you achieve and maintain healthy skin. Our team of
            experienced dermatologists provides a wide range of services
            and treatments, including acne and eczema treatment, skin
            cancer screenings, mole removal, and more.
            <br /><br />
            At our healthcare center, we understand that every patient
            has unique skin care needs and concerns. That's why we take
            a personalized approach to dermatology, working closely with
            each patient to develop a customized treatment plan that
            addresses their specific concerns. Whether you're looking
            to improve the appearance of your skin, address a specific
            skin condition, or simply maintain healthy skin, our
            dermatology team is here to help.
          </p>}
          img={sectionImg1}
          btn={
            <AppButton
              label="Discover More"
              buttonType="secondaryBtn shadowHover"
            />
          }
        />
        <PageSection
          direction="rtl"
          subtitle="Investing in Your Skin's Health"
          title="Our Dermatology Services and Patient Education"
          text={<><p>
            Healthy skin is an important part of overall well-being,
            and our dermatology services are designed to help our
            patients achieve just that. By providing comprehensive
            care and treatment for a wide range of skin conditions,
            we're able to help our patients feel confident and
            comfortable in their own skin. Here are just a few
            ways our dermatology services can help patients live
            healthier and better lives:
            <br />
          </p>
            <ul>
              <li>Clearer skin: We provide a range of treatments for conditions like acne, rosacea, and eczema</li>
              <li>Early detection of skin cancer: Regular skin cancer screenings can help detect skin cancer early.</li>
              <li>Improved skin tone and texture: Our cosmetic dermatology services can help improve the texture and tone of the skin.</li>
              <li>Relief from uncomfortable symptoms: Skin conditions like psoriasis and hives can cause itching, pain, and discomfort.</li>
              <li>Preventative care: Regular skin check-ups and exams can help identify potential issues before they become more serious.</li>
            </ul>
          </>}
          img={sectionImg2}
          btn={
            <AppButton
              label="Learn More"
              buttonType="secondaryBtn shadowHover"
            />
          }
        />
        <SiteGrid className="section section-3">
          <IconsBarSection
            title="Helping you maintain healthy skin."
            subtitle="Our Dermatology Services"
            data={dermatologyData}
          />
        </SiteGrid>
        <MakeAppointment />
      </div>
    </div>
  )
}
